export const opacity = {
  default: "100%",
  semiOpaque: "90%",
  intense: "75%",
  medium: "50%",
  intermediate: "35%",
  light: "20%",
  semiTransparent: "10%"
}